<template>
  <Section title="Get in touch" background="fill-2" v-observe-visibility="intObseverCfg" pad-h pad-t last-section>
    <SectionSubTitle full-width>Get in touch with us for a cup of coffee or interesting job prospects!</SectionSubTitle>
    <div class="contact-info" v-scroll-reveal>
      <img src="@/assets/img/coffee.svg" />
      <Paragraph size="large">Storgata 65, N-9008 Tromsø</Paragraph>
    </div>
    <div class="contact-info" v-scroll-reveal>
      <img src="@/assets/img/message.svg" />
      <Paragraph size="large"><a href="mailto:contact@orcalabs.no">contact@orcalabs.no</a></Paragraph>
    </div>
  </Section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Contact',

  data() {
    return {
      intObseverCfg: {
        callback: this.setTopic,
        intersection: {
          rootMargin: '-400px',
        },
      },
    };
  },

  computed: mapState(['isScrolling']),

  methods: {
    setTopic: function (isVisible) {
      if (isVisible && !this.isScrolling) {
        this.$router.push({ path: '#contact', query: { scroll: false } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @include respond-to('small') {
    flex-direction: row;
    justify-content: flex-start;
  }

  img {
    margin-right: 30px;
    height: 50px;
  }
}
</style>
